import type { IntlFormatters } from "@formatjs/intl/src/types";
import { isType } from "forms/helpers/checkJsonSchemaType";
import type { IProperty } from "types/jsonSchema";
import { z } from "zod";

export default function parsePhoneField(field: IProperty, formatMessage: IntlFormatters["formatMessage"] = () => "") {
    const isNullable = isType(field.type, "null");

    let schema = z.string().trim();

    if (field?.minLength || !isNullable) schema = schema.min(field.minLength ?? 1);
    if (field?.maxLength) schema = schema.max(field.maxLength);
    if (field?.pattern) {
        schema = schema.regex(new RegExp(field.pattern), {
            error: formatMessage({
                id: "errors.invalid_string.patternPhone",
            }),
        });
    }

    return schema;
}
